import { CommonModule } from '@angular/common';
import { Component, NgModule, OnInit } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Router, RouterLink } from '@angular/router';
import { DataService } from '../../Services/Data Service/data.service';
import { AuthService } from '../../Auth/auth.service';
import { isAdminRole } from '../../roles';

interface ResetData {
  email: string;
  strToken: string;
  strPassword: string;
}

@Component({
  selector: 'app-password-reset',
  templateUrl: './reset-password.component.html',
  standalone: true,  
  imports: [
    FormsModule,
    ReactiveFormsModule,
    CommonModule,
    RouterLink,
  ],
  styleUrls: ['./reset-password.component.css']
})
export class ResetPasswordComponent implements OnInit {
  title: string = 'Reset Password';
  error_message: string = '';
  tokenSent: boolean = false;
  tokenVerified: boolean = false;
  loading: boolean = false;

  resetData: ResetData = {
    email: '',
    strToken: '',
    strPassword: ''
  };

  readonly backgrounds = [
    'assets/unipet-bg2.jpg',
    'assets/unipet-bg3.jpg' ]
  randomNumber = Math.floor(Math.random() * this.backgrounds.length);

  bgImage = this.backgrounds[this.randomNumber]

  constructor(
    private router: Router, private dataservice: DataService, private auth: AuthService
    //TODO: Add actual auth service
  ) { }

  ngOnInit(): void { }

  onEmailInput(event: any): void {
    const email = event.target.value;
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    
    if (!emailRegex.test(email)) {
      this.error_message = 'Please enter a valid email address';
    } else {
      this.error_message = '';
    }
  }

  validatePassword(password: string, confirmPassword: string): void {
    if (password.length < 8) {
      this.error_message = 'Password must be at least 8 characters long';
      return;
    }

    const hasUpperCase = /[A-Z]/.test(password);
    const hasLowerCase = /[a-z]/.test(password);
    const hasNumbers = /\d/.test(password);
    const hasSpecialChar = /[!@#$%^&*(),.?":{}|<>]/.test(password);

    if (!hasUpperCase || !hasLowerCase || !hasNumbers || !hasSpecialChar) {
      this.error_message = 'Password must contain uppercase, lowercase, numbers, and special characters';
      return;
    }

    if (password !== confirmPassword) {
      this.error_message = 'Passwords do not match';
      return;
    }

    this.error_message = '';
  
  }




  //TODO: Implement token functionality 
  async onSubmit(): Promise<void> {
    try {
     if (!this.tokenSent) {
        // Step 1: Request reset token
        // await this.authService.requestPasswordReset(this.resetData.strEmail);
        this.tokenSent = true;
      } 
      else if (!this.tokenVerified) {
        // Step 2: Verify token
        // await this.authService.verifyResetToken(this.resetData.strEmail, this.resetData.strToken);
        this.tokenVerified = true;
      } 
      else {
        // Step 3: Reset password
        // await this.authService.resetPassword(
        //   this.resetData.strEmail,
        //   this.resetData.strToken,
        //   this.resetData.strPassword
        // );
        
        // Show success message
        alert('Password has been reset successfully!');
        // Redirect to login
        this.router.navigate(['/']);
      }
    } catch (error: any) {
      this.error_message = error.message || 'An error occurred. Please try again.';
    }
  }
 response :any ;

 sendResetToken(email: string) {
  this.loading = true;

  if (this.error_message != ''){
    this.loading = false
    return;
  }

  this.dataservice.EmailPasswordReset(email).subscribe({
    next: (response) => {
        this.loading = false;
        this.tokenSent = true;
        this.tokenVerified= false;
        // now you can proceed to token entry UI or call the next logic
        // optionally call onSubmit() if needed
    },
    error: (err) => {
      this.loading = false;
        this.error_message = 'Server error. Check email entered.';
    }
  });
}

  
resetErrorMessage() {
  this.error_message = "";
}

// Step 2: Call this after user enters temp password from email
validateVerificationToken(email: string, tempPassword: string) {
  this.loading = true;
  this.error_message = '';

  this.auth.login(email, tempPassword).subscribe({
    next: (loginResponse) => {
      if (!this.tokenVerified) {
      
        this.tokenVerified = true;
      } 
      this.loading = false;
      console.log('token successful', loginResponse);
    },
    error: (err) => {
      this.loading = false;
      console.error('token failed:', err);
      this.error_message = 'Invalid token. Please try again';
      // alert('token failed. Please check your temporary password.');
    }
  })
}

changePassword(email: string, newPassword: string) {
  this.loading = true;

  const payload = {
    email,
    newPassword
  };
  console.log(payload)
  this.dataservice.ChangePassword(payload).subscribe({
    next: (loginResponse) => {
      this.loading = false;

      console.log('Login successful', loginResponse);
      // redirect or navigate
      this.login();
    },
    error: (err) => {
      this.loading = false;
      console.error('Login failed:', err);
      alert('Login failed. Please check your temporary password.');
    }
  });
}

login(): void {
  this.loading = true;
  this.auth.login(this.resetData.email, this.resetData.strPassword).subscribe(
    (response) => {
      console.log('Raw login response:', response);
      
      if (response && response.accessToken && response.refreshToken) {
        this.loading = false;
        console.log('JWT token received:', response.accessToken);
        console.log('Refresh token received:', response.refreshToken);
        this.auth.storeCredentials(this.resetData.email, response.accessToken, response.refreshToken);
        this.auth.setAccessToken(response.accessToken);

        this.dataservice.getCurrentUser().subscribe({
          next: (user) => {
            if (!user) {
              console.error('User not found after login');
              return;
            }

            console.log('User found:', user);

            // Navigate based on role
            if (isAdminRole(user.role)) {
              this.router.navigate(['/dashboard']);
            } else if (user.role === 'Vendor') {
              this.router.navigate(['/registrationform']);
            } else {
              console.warn('Unknown role:', user.role);
            }
          },
        });
      } else {
        this.loading = false;
        console.warn('Unexpected response structure:', response);
        this.error_message = 'Unexpected response from server.';
      }
    },
    (error) => {
      this.loading = false;
      if (error.status === 401) {
        this.error_message = 'Invalid username or password.';
      } else if (error.status === 500) {
        this.error_message = 'An unexpected server error occurred. Please try again.';
      } else {
        this.error_message = 'Server error. Please try again later.';
      }
      console.error('Login error details:', error);
    }
  );
}

}
